'use strict';

import angular from 'angular';

export default function($http, $parse, toastr) {
	'ngInject';

	return {
		restrict: 'A',
		link: postLink,
	};

	function postLink(scope, element, attrs) {
		if (window.ClipboardJS === undefined) {
			console.error('No access to ClipboardJS.');
			return;
		}
		const clipboard = new window.ClipboardJS(element[0]);
		element.on('$destroy', () => {
			clipboard.destroy();
		});
		clipboard.on('success', () => {
			toastr.success(attrs.successMessage || 'Copied to clipboard!');
		});
	}
}
